import script from "./MyFavourites.vue?vue&type=script&setup=true&lang=js"
export * from "./MyFavourites.vue?vue&type=script&setup=true&lang=js"

import "./MyFavourites.vue?vue&type=style&index=0&id=63237c35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63237c35"]])

export default __exports__